import React from 'react';
import PropTypes from 'prop-types';

import classes from './Button.module.css';

const Button = ({ disabled, active, className, onClick, children, style, onMouseEnter, onMouseLeave }) => {
  return (
    <button
      type="submit"
      disabled={disabled}
      data-active={active}
      className={`${className} ${classes.Button}`}
      onClick={onClick}
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

Button.defaultProps = {
  disabled: false,
  active: false,
  className: '',
  onMouseEnter: () => { },
  onMouseLeave: () => { },
};

export default Button;
